/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PreviewReminderEmailRequest model module.
 * @module model/PreviewReminderEmailRequest
 * @version V1
 */
class PreviewReminderEmailRequest {
    /**
     * Constructs a new <code>PreviewReminderEmailRequest</code>.
     * @alias module:model/PreviewReminderEmailRequest
     */
    constructor() { 
        
        PreviewReminderEmailRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PreviewReminderEmailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PreviewReminderEmailRequest} obj Optional instance to populate.
     * @return {module:model/PreviewReminderEmailRequest} The populated <code>PreviewReminderEmailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PreviewReminderEmailRequest();

            if (data.hasOwnProperty('subject')) {
                obj['subject'] = ApiClient.convertToType(data['subject'], 'String');
            }
            if (data.hasOwnProperty('body')) {
                obj['body'] = ApiClient.convertToType(data['body'], 'String');
            }
            if (data.hasOwnProperty('approverId')) {
                obj['approverId'] = ApiClient.convertToType(data['approverId'], 'Number');
            }
            if (data.hasOwnProperty('proofId')) {
                obj['proofId'] = ApiClient.convertToType(data['proofId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PreviewReminderEmailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PreviewReminderEmailRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['subject'] && !(typeof data['subject'] === 'string' || data['subject'] instanceof String)) {
            throw new Error("Expected the field `subject` to be a primitive type in the JSON string but got " + data['subject']);
        }
        // ensure the json data is a string
        if (data['body'] && !(typeof data['body'] === 'string' || data['body'] instanceof String)) {
            throw new Error("Expected the field `body` to be a primitive type in the JSON string but got " + data['body']);
        }

        return true;
    }


}



/**
 * @member {String} subject
 */
PreviewReminderEmailRequest.prototype['subject'] = undefined;

/**
 * @member {String} body
 */
PreviewReminderEmailRequest.prototype['body'] = undefined;

/**
 * @member {Number} approverId
 */
PreviewReminderEmailRequest.prototype['approverId'] = undefined;

/**
 * @member {Number} proofId
 */
PreviewReminderEmailRequest.prototype['proofId'] = undefined;






export default PreviewReminderEmailRequest;

